module.exports = __webpack_public_path__ + "static/media/06_digginglight.ac9b519c.jpg";